export default {
  questionTitle: 'Nous joindre ?',
  contactUsTitle: 'Vous ne trouvez pas les réponses que vous recherchez?',
  contactUsText: 'Nous sommes là pour vous aider.',
  linkText: 'Nous joindre',
};
